import { Pipe, PipeTransform } from '@angular/core';
import {UserToBoardRelation, UserRelatedBoard} from "../modele/boardModel";
import {NGXLogger} from "ngx-logger";
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | filterBoardsBasedOnRelations:relations? UserToBoardRelation[]
 * Example:
 *   {{ ["follow", "own"] | exponentialStrength:["own", "follow"] }}
 *   formats to: 1024
 */

@Pipe({name: 'filterBoardsBasedOnRelations'})
export class filterBoardsBasedOnRelationsPipe implements PipeTransform {


    transform(boards:UserRelatedBoard[], inputFilterList:string, allNeedToMatch:boolean, boardRelationsNeedToMatchExactly:boolean,logger?:NGXLogger,length?:number): UserRelatedBoard[] {
        let subSet:UserRelatedBoard[]=[];
        let lp="filterBoardsBasedOnRelationsPipe:";
        if(logger!=null){
            //logger.info(lp,"filter: got board",boards,"got: filter:[",inputFilterList,"]");
            if(inputFilterList.length==0){
                return boards;
            }
            let keyWords = inputFilterList.split(' ');
            //logger.debug(lp,"filter: got filter list",inputFilterList,"-->len[",keyWords.length,"]",keyWords);
            let count = 0;
            let filteredBoardList = boards.map(board => {
               //logger.info(lp,"filter:board:",board.board_id,"::relations:",board.relations);
               count = 0;
               let anyMatchingKeyWords = board.relations.map(relation =>{
                   let matchingKeyWords = keyWords.map(keyWord => {
                       let expression=(relation.relation.includes(keyWord) );
                       //logger.debug(lp,"filter:board:relation:",relation.relation,"::",keyWord, "==",expression);
                       return expression;
                   });
                   //logger.debug(lp,"filter:board:",board.board_id,"::relations:",board.relations,"matches:",matchingKeyWords);
                   if(matchingKeyWords[0] == true){
                       count++;
                   }
                   return matchingKeyWords[0];
               }).reduce((previous_val, current_val, cur_index)=>{
                   return (previous_val||current_val);
               });
                //logger.debug(lp,"filter:board:matching keywords:",anyMatchingKeyWords,"::typeof",typeof anyMatchingKeyWords,"::count:",count);

                if(keyWords.length > 1 ){
                    //if(board.matchesAllRelations([new UserToBoardRelation("follow")]))
                    if(anyMatchingKeyWords == true ){
                        // logger.debug(lp,"MODE_A::filter:board:matching keywords>1:",anyMatchingKeyWords,"::keywordList[",keyWords,"] -> push board");
                        // logger.debug(lp,"MODE_A::filter:board:matching keywords>1:ALL_NEED_TO_MATCH:",allNeedToMatch);
                        if(boardRelationsNeedToMatchExactly == false){
                            // if(allNeedToMatch == true){
                            //
                            // }
                            subSet.push(board);
                        } else {
                            // logger.debug(lp,"MODE_A-> all need to match != false->",(board.relations.length==keyWords.length))
                            if(board.relations.length==keyWords.length){
                                subSet.push(board);
                                // logger.debug(lp,"MODE_A-> all need to match true-> push board")
                            }

                        }

                        if(allNeedToMatch!=null && allNeedToMatch == true){

                        }
                        return board;
                    }
                } else {
                    if(anyMatchingKeyWords == true){
                        // logger.debug(lp,"MODE_B::filter:board:matching keywords>=1:",anyMatchingKeyWords,"::keywordList[",keyWords,"] -> push board");
                        subSet.push(board);
                        return board;
                    }
                }

            }).filter(x => x != null);
            length = filteredBoardList.length

            return filteredBoardList;
        }
        return subSet.filter(x => x != null);
    }

}
